import React, {useState, useEffect, useContext, useRef} from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import {useRouter} from "next/router";
import styled from "styled-components";
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import AppLayout from "@layouts/app.layout";
import {UserContext, UserDispatcherContext} from "@providers/user";
import {PropertiesContext, PropertiesDispatcherContext} from "@providers/properties";
import {checkUrlParams, linkTypes} from "@models/check_link";
import {getBookmarkedPropertiesIds, getProperty, handlePropertyFollow, getPropertyTypes, getUrlDealTypes, getUrlTypes} from "@models/property";
import Navbar from "@organisms/navbar/navbar";
import SwiperSlider from "@organisms/property/show/slider/swiper";
import TopFixedActions from "@organisms/property/show/top.fixed.actions";
import {handleTypeTitle, handleTitle, getPropertyUrl, checkUserModality} from "@organisms/property/helpers/property_helpers";
import MainInfo from "@organisms/property/show/info";
import Features from "@organisms/property/show/features";
import Facilities from "@organisms/property/show/facilities";
import Contact from "@organisms/property/show/contact";
import SimilarProperties from "@organisms/property/similar";
import MapSrc from "@molecules/maps/map.src";
import Share from "@molecules/modals/share";
import PropertyReport from "@organisms/property/report";
import {handleFooterLinks} from "@organisms/footer/helpers";
import {handleNavbarLinks} from "@organisms/navbar/helpers";
import HotLinks from "@atoms/hot.links";
import Divider from "@atoms/divider";
import Alert from "@atoms/alert";
import {array_unique} from "@helpers/arrays";
import {nl2br, str_replace, isEmpty, scrollToTop} from "@helpers/helpers";
import {formatPhoneNumber} from "@helpers/numbers";
import {useWindowSize} from "@helpers/windows.size";
import Icon from "@atoms/icon";
import ButtonTransparent from "@atoms/button.transparent";
import useTrans from "@hooks/translation";
import {getCity, setDefaultCity} from "../../models/district";
import {getDefaultCity} from "../../components/hooks/cities";
import {getImagePath, getSearchiDealTypes} from "../../models/property";
import CrmPropertyRequestForm from "../../components/organisms/property/crm_requests/crm_property_request_form";
import ButtonBase from "../../components/atoms/button.base";
import {scrollToOffsetTop} from "../../components/helpers/helpers";
import {handleFixedButtonShowAndHide} from "../../components/organisms/property/show/helpers";
import {GoogleTagManagerEvent} from "../../components/helpers/google_tag_events";
import InvestmentBanner from "../../components/molecules/banners/investment_banner";
import VisitableIcon from '@icons/visitable.svg';
import FlagIcon from "@icons/flag.svg";
import SearchIcon from "@icons/search.svg";
import ArrowRightIcon from "@icons/arrow-right.svg";
import ChevronLeftIcon from '@icons/chevron-left.svg';
import DelMiniIcon from '@icons/del-mini.svg';
import "@assets/scss/swiper/swiper.scss";

const Location = dynamic(() => import("@organisms/property/show/location"), {ssr: false,});


const map_type = 'neshan';

function Show({ssrProperty, footerLinks, navbarLinks, prop_property_id, propIsBadeSaba, defaultCityId}) {
    const sidebarRef = useRef('');
    const fixButtonRef = useRef('');
    const router = useRouter();
    const windowSize = useWindowSize();
    const userContext = React.useContext(UserContext);
    const userDispatcherContext = React.useContext(UserDispatcherContext);
    const properties_context = useContext(PropertiesContext);
    const properties_dispatcher = useContext(PropertiesDispatcherContext);

    const [isBadeSaba, setIsBadeSaba] = useState(false);
    const [share, setShare] = useState(false);
    const [report, setReport] = useState(false);
    const [login, setLogin] = useState({show: false, callback: undefined});
    const [bookmarkedProperties, setBookmarkedProperties] = useState([]);
    const [propertyState, setProperty] = useState(null);
    const [perContact, setPerContact] = useState({show: false, property_id: null, phone: ''});
    const [quickContact, setQuickContact] = useState({show: false, phone: ''});
    const [hotLinkItems, setHotLinkItems] = useState([]);

    const property = !isEmpty(ssrProperty) ? ssrProperty : propertyState;

    const handleLoginWithCallback = (show, callable = undefined) => {
        setLogin({
            show: show,
            callback: callable
        })
    };

    const bookmarkProperty = (follow = true) => {
        let bookmarked = [...bookmarkedProperties];

        if (follow) {
            bookmarked.push(property.id);
        } else {
            for (let key in bookmarked) {
                if (bookmarked[key] === property.id) {
                    delete bookmarked[key];
                }
            }
        }
        setBookmarkedProperties(array_unique(bookmarked));

        handlePropertyFollow(property.id, follow).then(result => {

            setBookmarkedProperties(array_unique(bookmarked));
        }).catch(err => {
            console.log(err)
        })
    };

    const handleBookmark = (follow = true) => {
        if (userContext.check) {

            bookmarkProperty(follow);
        } else {
            setLogin({show: true, callback: bookmarkProperty})
        }
    };

    const handleHotlinksAndContactAfterProperty = (property) => {
        let showRequestForm = properties_context.pushState.isBadeSaba;
        const pageIsBadesaba = ((isEmpty(showRequestForm) || !showRequestForm) && !isEmpty(propIsBadeSaba));
        if (pageIsBadesaba) {
            showRequestForm = true;
        }

        const {city_name, district_name, type, deal_type} = property;
        const typeName = getPropertyTypes(type);
        const dealTypeName = getSearchiDealTypes(deal_type);
        const dealTypeUrl = getUrlDealTypes(deal_type);
        const typeUrl = getUrlTypes(type);

        setPerContact({show: false, property_id: property.id});

        if (!isEmpty(property.contact_info) && (!isEmpty(property.contact_info.realtor_phone1) || !isEmpty(property.contact_info.phone1))) {
            setQuickContact({phone: !isEmpty(property.contact_info.realtor_phone1) ? property.contact_info.realtor_phone1 : property.contact_info.phone1})
        }

        const typeAndDealTypeUrl = dealTypeUrl + '-' + typeUrl;
        const cityHotLinkUrl = '/املاک-' + str_replace(' ', '-', city_name) + '/' + typeAndDealTypeUrl + (showRequestForm ? '?badesaba=true' : '');
        const districtHotLinkUrl = '/املاک-' + str_replace(' ', '-', city_name) + '/' + typeAndDealTypeUrl + '/' + str_replace(' ', '-', district_name) + (showRequestForm ? '?badesaba=true' : '');

        let hotLinkItems = [
            {href: cityHotLinkUrl, hrefAs: cityHotLinkUrl, title: dealTypeName + ' ' + typeName + ' در ' + city_name, icon: <SearchIcon/>},
        ];

        if (city_name !== district_name) {
            hotLinkItems.push({href: districtHotLinkUrl, hrefAs: districtHotLinkUrl, title: dealTypeName + ' ' + typeName + ' در ' + district_name, icon: <SearchIcon/>})
        }

        setHotLinkItems(hotLinkItems);

        handleUserModality(property.city_id, property.district_id, property.deal_type, pageIsBadesaba);
    }

    useEffect(() => {
        if (userContext.check) {
            getBookmarkedPropertiesIds(userContext.user.id).then(result => {
                setBookmarkedProperties(result.properties);
            }).catch(err => {
                console.log(err)
            });
        }
    }, [userContext]);

    useEffect(() => {
        scrollToTop();

        if (!isEmpty(prop_property_id) && isEmpty(ssrProperty)) {
            setQuickContact({show: false, phone: ''});
            setProperty(null);

            let showRequestForm = properties_context.pushState.isBadeSaba;
            const pageIsBadesaba = ((isEmpty(showRequestForm) || !showRequestForm) && !isEmpty(propIsBadeSaba));
            if (pageIsBadesaba) {
                showRequestForm = true;
            }

            setIsBadeSaba(showRequestForm);

            getProperty(prop_property_id).then(property => {

                if (showRequestForm) {
                    property.isBadeSaba = true;
                }

                setProperty(property);
            }).catch(err => {
                console.log(err)
            });
        }

        properties_dispatcher({
            type: 'PUSH_STATE',
            payload: {
                loading: false,
            }
        });

        history.scrollRestoration = 'manual';

    }, [prop_property_id]);

    useEffect(() => {
        if (!isEmpty(property)) {

            handleHotlinksAndContactAfterProperty(property);

            const detailsHiddenNumbers = document.querySelectorAll('.details-hidden-numbers');
            if (detailsHiddenNumbers.length) {
                for (let number of detailsHiddenNumbers) {
                    number.onclick = function () {
                        setQuickContact({show: true, phone: ''});
                        setPerContact({
                            show: true,
                            property_id: property.id,
                            city_id: property.city_id,
                        });
                    }
                }
            }
        }
    }, [property]);

    const handleUserModality = (city_id, district_id, deal_type, pageIsBadesaba) => {
        const data = {
            city_id: city_id,
            district_id: district_id,
            deal_type: deal_type
        };

        const check = checkUserModality(data);
        check.isBadeSaba = pageIsBadesaba;

        userDispatcherContext({
            type: 'MODALITY',
            payload: check,
        })
    };

    useEffect(() => {
        scrollToTop();

        router.beforePopState(() => {
            if (!document.body.classList.contains('modal-open') && !document.body.classList.contains('swiper-open')) {
                properties_dispatcher({
                    type: 'PUSH_STATE',
                    payload: {
                        back: true,
                    }
                });

                return true;
            }

            return false;
        })
    }, []);

    const handleScroll = () => {
        if (!isEmpty(sidebarRef.current) && !isEmpty(fixButtonRef.current)) {
            handleFixedButtonShowAndHide(sidebarRef.current.offsetTop, fixButtonRef)
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    const getParamsForTitleAndUrl = () => {
        let city_name = '';
        let type = 'apartment';
        let deal_type = 'sale';

        if (!isEmpty(property)) {
            city_name = property.city_name;
            type = property.type;
            deal_type = property.deal_type;
        } else {
            const city = getCity(getDefaultCity());

            if (!isEmpty(city)) {
                city_name = city.name;
            }
        }

        return {city_name, type, deal_type}
    };

    const handleBackToListUrl = () => {
        const {city_name, type, deal_type} = getParamsForTitleAndUrl();

        const cityUrl = '/املاک-' + str_replace(' ', '-', city_name);
        const dealTypeUrl = getUrlDealTypes(deal_type);
        const typeUrl = getUrlTypes(type);

        return cityUrl + '/' + dealTypeUrl + '-' + typeUrl + (isBadeSaba ? '?badesaba=true' : '');
    };

    const handleTitleBackToListUrl = () => {
        const {city_name, type, deal_type} = getParamsForTitleAndUrl();

        return getSearchiDealTypes(deal_type) + ' ' + useTrans('type.' + type) + ' در ' + city_name;
    };

    const handlePageTitleAndDescription = () => {
        let title = '';

        if (!isEmpty(property)) {
            title = handleTypeTitle(property.deal_type, property.type, property.villa_type) + ' ' + handleTitle(property, true, null, null, true) + ' - ' + property.id
        }

        return title;
    };

    const clickOnFixedBottomBtn = () => {
        const propertyRequestCard = document.getElementById('showPropertyLeftSide');

        const event = 'invest-request-form-view-on-show';

        GoogleTagManagerEvent(event);

        scrollToOffsetTop(propertyRequestCard.offsetTop, 40)
    };

    const getPropertyImagesForMeta = (property) => {
        let images = [];

        if (!isEmpty(property) && property.media && property.media.length) {
            for (const media of property.media) {

                if (media.type !== 'video' && media.is_cover) {
                    images.push(getImagePath(property.id, media, property.boosted_at))
                }
            }

            if (!images.length) {
                images.push(getImagePath(property.id, property.media[0], property.boosted_at))
            }
        }

        return images;
    }

    return (
        <AppLayout
            footerLinks={footerLinks}
            pageRobots="NOODP, nofollow, noindex"
            pageTitle={handlePageTitleAndDescription()}
            pageDescription={handlePageTitleAndDescription()}
            ogDescription={handlePageTitleAndDescription()}
            pageCanonicalLink={!isEmpty(property) ? getPropertyUrl(property, propIsBadeSaba) : ''}
            pageImages={getPropertyImagesForMeta(property)}
            className={'show-property ' + (!isEmpty(property) && property.archived ? '' : "pb-80 pb-md-0")}
            footer={(!isBadeSaba)}
            investmentPageSection="properties"
            investmentPageView="show"
            selectedCityId={defaultCityId}
        >

            <SkeletonTheme color={props => props.theme.gray200} highlightColor="#444">

                <MapSrc map_type={map_type}/>

                <Navbar
                    investmentEventSection="properties"
                    investmentEventView="show"
                    fixed
                    navbarLinks={navbarLinks}
                    selectedCityId={defaultCityId}
                    className="d-none d-md-block"
                    showLoginModal={login.show}
                    setShowLoginModal={handleLoginWithCallback}
                    loginCallback={login.callback}
                    isBadeSaba={isBadeSaba}
                />

                <TopFixedActions
                    isBadeSaba={isBadeSaba}
                    property={property}
                    bookmarkedProperties={bookmarkedProperties}
                    setShare={setShare}
                    handleBookmark={handleBookmark}
                    handleBackToListUrl={handleBackToListUrl}
                    className="d-md-none"
                />

                {
                    (!isEmpty(property) && property.archived) ?
                        <ArchivedCard>
                            <Alert type="warning" className="py-16 rounded-0">
                                <div className="container xs-fluid d-flex align-items-center">
                                    <Icon><DelMiniIcon/></Icon>
                                    <p className="mr-16 text-dark font-weight-bold">مدت زیادی از آگهی این ملک گذشته و از سایت حذف شده</p>
                                </div>
                            </Alert>


                            <SimilarProperties
                                property={property}
                                isBadeSaba={(!isEmpty(property.isBadeSaba) && property.isBadeSaba)}
                                className="container xs-fluid mt-40 mt-lg-48"/>

                            <Divider className="bg-gray100"/>
                        </ArchivedCard>
                        :
                        ''
                }


                <Card className={((!isEmpty(property) && property.archived) ? "archive-property" : '')}>
                    <div className="container xs-fluid">

                        {
                            (process.browser && history.length < 2) ?
                                <Link href="/properties" as={handleBackToListUrl()}>
                                    <a className="mb-24 d-none d-md-flex align-items-center text-black back-to-list">
                                        <Icon className="ml-8" width={16}><ArrowRightIcon/></Icon>
                                        {handleTitleBackToListUrl()}
                                    </a>
                                </Link>
                                :
                                <ButtonTransparent onClick={() => router.back()} className="mb-24 d-none d-md-flex align-items-center text-black back-to-list">
                                    <Icon className="ml-8" width={16}><ArrowRightIcon/></Icon>
                                    بازگشت
                                </ButtonTransparent>
                        }

                        {
                            (process.browser && ((!isEmpty(router.query) && !isEmpty(router.query.media)) || (!isEmpty(properties_context.pushState) && !isEmpty(properties_context.pushState.media)) || !isEmpty(property) || windowSize < 768)) ?
                                <SwiperSlider
                                    property={property}
                                    skeleton_count={(!isEmpty(router.query) && !isEmpty(router.query.media) && router.query.media > 0) ? router.query.media :
                                        ((!isEmpty(properties_context.pushState) && !isEmpty(properties_context.pushState.media) && properties_context.pushState.media > 0) ? properties_context.pushState.media :
                                            ((process.browser && window.innerWidth < 768) ? 1 : 0))
                                    }/>
                                :
                                ''
                        }
                    </div>

                    {
                        (!isEmpty(property)) ?
                            <Body className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <MainInfo
                                            property={property}
                                            bookmarkedProperties={bookmarkedProperties}
                                            handleBookmark={handleBookmark}
                                            setShare={setShare}
                                            perContact={perContact}
                                            setPerContact={setPerContact}
                                            quickContact={quickContact}
                                            isBadeSaba={isBadeSaba}
                                        />

                                        <Dividers/>

                                        <Features property={property}/>

                                        {
                                            (!isEmpty(property.facilities) && property.facilities.length) ?
                                                <React.Fragment>
                                                    <Dividers/>
                                                    <Facilities property={property}/>
                                                </React.Fragment>
                                                : ''
                                        }

                                        {
                                            (!isEmpty(property.description)) ?
                                                <React.Fragment>
                                                    <Dividers/>

                                                    <Descriptions>
                                                        <h2>توضیحات تکمیلی</h2>
                                                        <div className="mt-16" dangerouslySetInnerHTML={{__html: handleDescription(property, quickContact, setPerContact)}}/>
                                                    </Descriptions>
                                                </React.Fragment>
                                                : ''
                                        }

                                        {
                                            (!isEmpty(property.is_empty) && property.is_empty) ?
                                                <AlertIsEmpty className="my-32 my-lg-48">
                                                    <Alert className="border-gray200" type="white">
                                                        <Icon width={42} height={42}><VisitableIcon/></Icon>

                                                        <p className="mr-24 text-dark">
                                                            ملک تخلیه و مناسب بازدید با رعایت نکات بهداشتی در
                                                            <span className="font-weight-bold"> شرایط کرونا </span>
                                                            است.
                                                        </p>
                                                    </Alert>
                                                </AlertIsEmpty>
                                                :
                                                (
                                                    (!property.show_map || isEmpty(property.location)) ?
                                                        <Dividers className="b-block"/>
                                                        : ''
                                                )
                                        }

                                        {
                                            (
                                                (isEmpty(property.show_map) || property.show_map) &&
                                                !isEmpty(property.location) &&
                                                !isEmpty(property.location.latitude) &&
                                                !isEmpty(property.location.longitude)
                                            ) ?
                                                <React.Fragment>
                                                    {
                                                        (isEmpty(property.is_empty) || !property.is_empty) ?
                                                            <Dividers/>
                                                            : ''
                                                    }

                                                    <Location
                                                        center={[property.location.latitude, property.location.longitude]}
                                                        tapFullscreen={true}
                                                        zoom_control={windowSize > 991 ? true : false}
                                                        touchZoom={windowSize > 991 ? true : false}
                                                        map_type={map_type}/>

                                                    <Dividers className="b-block d-lg-none"/>
                                                </React.Fragment>
                                                : ''
                                        }


                                    </div>

                                    <div className="col-lg-1"/>

                                    <div ref={sidebarRef} id="showPropertyLeftSide" className="col-lg-4">

                                        <LeftSide>
                                            {
                                                (!isEmpty(property)) ?
                                                    (
                                                        (!isEmpty(property.isBadeSaba) && property.isBadeSaba && !property.archived) ?
                                                            <PropertyRequestCard className="p-32 d-flex flex-column align-items-center rounded-16 ">
                                                                <div className="h2 mb-16">این ملک رو پسندیدید؟</div>

                                                                <CrmPropertyRequestForm
                                                                    page="on_property_show"
                                                                    isBadeSaba={isBadeSaba}
                                                                    property_id={property.id}
                                                                    city_id={property.city_id}
                                                                    district_id={property.district_id}
                                                                />
                                                            </PropertyRequestCard>
                                                            :
                                                            <Contact
                                                                property={property} //
                                                                perContact={perContact}
                                                                setPerContact={setPerContact}
                                                                setQuickContact={setQuickContact}
                                                                setShowLoginWithCallback={handleLoginWithCallback}
                                                            />
                                                    )
                                                    :
                                                    <div className="w-100 shadow bg-white p-32 text-center rounded-16">
                                                        <Skeleton width={88} height={88} circle={true}/>

                                                        <div className="mt-16 d-flex justify-content-center flex-column">
                                                            <Skeleton width={'70%'}/>
                                                            <Skeleton width={'50%'}/>
                                                        </div>

                                                        <div className="">
                                                            <Skeleton width={'70%'}/>
                                                        </div>

                                                        <div className=" mt-16">
                                                            <Skeleton width={'100%'} height={48}/>
                                                        </div>
                                                    </div>
                                            }

                                            {
                                                (!isEmpty(property) && !property.archived) ?
                                                    <div className="mt-40 text-center">
                                                        <ReportButton onClick={() => setReport(true)} className="d-flex d-lg-inline-flex align-items-center">
                                                            <span className="d-flex align-items-center">
                                                                <Icon width={16}>
                                                                    <FlagIcon/>
                                                                </Icon>
                                                                <span className="mr-16">گزارش مشکل آگهی</span>
                                                            </span>

                                                            <Icon className="d-block d-lg-none " width={12} height={15}>
                                                                <ChevronLeftIcon/>
                                                            </Icon>
                                                        </ReportButton>
                                                    </div>
                                                    :
                                                    <Dividers className="b-block d-lg-none mb-0"/>
                                            }
                                        </LeftSide>
                                    </div>
                                </div>

                                {
                                    (!isEmpty(property)) ?
                                        <div className={(isEmpty(property.show_map) || property.show_map) ? (property.archived ? "mt-32" : "mt-56") : 'mt-56 mt-lg-0'}>
                                            <h2 className="mb-24">جستجوهای مشابه</h2>

                                            <HotLinks items={hotLinkItems}/>
                                        </div>
                                        : ''
                                }

                            </Body>

                            :

                            <Body className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <Skeleton width={150}/>

                                            <div className="d-none d-lg-block">
                                                <Skeleton width={24} height={24} circle={true}/>
                                                <Skeleton className="mr-8" width={24} height={24} circle={true}/>
                                            </div>
                                        </div>

                                        <Skeleton width={'70%'}/>

                                        <div className="d-flex align-items-center">
                                            <Skeleton width={200}/>
                                        </div>

                                        <div className="mt-40 mt-lg-48">
                                            <Skeleton className="" width={80}/>
                                            <Skeleton className="d-none d-lg-block" width={100}/>
                                            <Skeleton className="d-none mt-8 d-lg-block" width={150}/>
                                        </div>

                                        <Skeleton className="mt-40" width={'100%'} height={112}/>
                                    </div>

                                    <div className="col-lg-1"/>

                                    <div className="col-lg-4 d-none d-lg-block">
                                        <div className="w-100 shadow bg-white p-32 text-center rounded-16">

                                            <Skeleton width={88} height={88} circle={true}/>

                                            <div className="mt-16 d-flex justify-content-center flex-column">
                                                <Skeleton width={'70%'}/>
                                                <Skeleton width={'50%'}/>
                                            </div>

                                            <div className="">
                                                <Skeleton width={'70%'}/>
                                            </div>

                                            <div className=" mt-16">
                                                <Skeleton width={'100%'} height={48}/>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Body>
                    }

                    {
                        (!isEmpty(property) && !property.archived) ?
                            <SimilarProperties property={property} isBadeSaba={(!isEmpty(property.isBadeSaba) && property.isBadeSaba)} className="container xs-fluid mt-48"/>
                            :
                            ''
                    }

                    {
                        (!isEmpty(property) && userContext && !userContext.isRealtor && userContext.modality && userContext.modality.show_invest) ?
                            <div className="container mt-48 mt-lg-56">
                                <InvestmentBanner
                                    eventSection="properties"
                                    eventView="show"
                                    isBadeSaba={isBadeSaba}
                                    userModality={userContext.modality}/>
                            </div>
                            : ''
                    }
                </Card>

                {
                    (!isEmpty(property)) ?
                        <React.Fragment>

                            <Share
                                isBadeSaba={isBadeSaba}
                                property={property}
                                show={share}
                                setShow={setShare}
                            />

                            <PropertyReport property_id={property.id} show={report} setShow={setReport}/>
                        </React.Fragment>

                        : ''
                }

                {
                    (!isEmpty(property) && (isBadeSaba || property.request_contact)) ?
                        <FixInBottom ref={fixButtonRef}>
                            <ButtonBase onClick={clickOnFixedBottomBtn} block color="secondary">اطلاعات تماس</ButtonBase>
                        </FixInBottom>
                        : ''
                }

            </SkeletonTheme>
        </AppLayout>
    );
}

Show.getInitialProps = async (context) => {
    const {asPath, query, pathname, res, req} = context;
    let property_id = '';
    let isBadeSaba = '';
    let defaultCityId = 259;

    if (req && req.cookies && !isEmpty(req.cookies['default_city_id'])) {
        defaultCityId = req.cookies['default_city_id'];
    } else if (process.browser) {
        defaultCityId = getDefaultCity();
    }

    if (!process.browser && !isEmpty(query) && !isEmpty(query['badesaba'])) {
        isBadeSaba = true;
    }

    await checkUrlParams(asPath, linkTypes.PROPERTY_SHOW).then(result => {
        if (!isEmpty(result.property_id)) {
            property_id = result.property_id
        }

        if (!isEmpty(result.query) && typeof result.query === "object") {
            defaultCityId = result.query.city_id;
            setDefaultCity(result.query.city_id, context); // save default city in cookie
        }
    });

    let footerLinks = null;
    let navbarLinks = null;
    let property = null;

    if (!process.browser) {
        footerLinks = await handleFooterLinks(defaultCityId);
        navbarLinks = await handleNavbarLinks(defaultCityId);

        if (!isEmpty(property_id)) {
            try {
                property = await getProperty(property_id);

                property.isBadeSaba = isBadeSaba ?? false;
            } catch (e) {

            }
        }
    }

    return {
        prop_property_id: property_id,
        ssrProperty: property,
        propIsBadeSaba: isBadeSaba,
        navbarLinks: navbarLinks,
        footerLinks: footerLinks,
        defaultCityId: defaultCityId
    }
};

export default Show;

function handleDescription(property, quickContact, setPerContact) {
    let description = property.description;
    const mobiles = description.match(/[0-9۱۲۳۴۵۶۷۸۹۰]{1}[0-9۱۲۳۴۵۶۷۸۹۰\-]{9,20}[0-9۱۲۳۴۵۶۷۸۹۰]{1}/g);


    if (!isEmpty(mobiles) && typeof mobiles === "object" && mobiles.length) {
        for (let mobile of mobiles) {
            const formatMobile = formatPhoneNumber(mobile, 'mobile', (!quickContact.show));
            const element = '<span class="mx-1 cursor-pointer details-hidden-numbers ' + ((!quickContact.show) ? 'ltr text-secondary' : '') + '" >' + formatMobile + '</span>';

            if (!property.archived && (!property.request_contact && (isEmpty(property.isBadeSaba) || !property.isBadeSaba))) {
                description = str_replace(mobile, element, description);
            } else {
                description = str_replace(mobile, '****', description);
            }
        }
    }

    return nl2br(description)
}

// styles

const PropertyRequestCard = styled.div`
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.12);
  background-color: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.gray200};

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 0;
  }
`;

const LeftSide = styled.div`
  @media (min-width: ${(props) => props.theme.screenSmMax}) {
    position: sticky;
    left: 24px;
    top: 112px;
    z-index: 48;
  }
`;

const Dividers = styled(Divider)`
  margin: 48px 0 !important;
  @media (max-width: ${(props) => props.theme.screenXsMax}) {
    margin: 32px 0 !important;
  }
`;

const Descriptions = styled.div`
  line-break: anywhere;
`;

const Body = styled.div`
  margin-top: 48px;
  @media (max-width: ${(props) => props.theme.screenXsMax}) {
    margin-top: 24px;
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
`;

const Card = styled.div`
  margin-top: 100px;
  margin-bottom: 72px;

  @media (max-width: ${(props) => props.theme.screenSmMax}) {
    margin-top: 55px;
    margin-bottom: 64px;
  }

  &.archive-property {
    margin-top: 0;

    .back-to-list {
      display: none !important;
    }
  }

  .back-to-list {
    svg {
      g {
        stroke: ${(props) => props.theme.black};
      }
    }
  }
`;

const ArchivedCard = styled.div`
  margin-top: 80px;

  .divider {
    margin: 48px 0;
    border-width: 32px;
    border-color: ${props => props.theme.gray100};
  }

  .alert {
    .icons {
      width: 56px;
      min-width: 56px;
    }

    p {
      font-size: 1.125rem;
    }
  }


  @media (max-width: ${(props) => props.theme.screenSmMax}) {
    margin-top: 55px;

    .alert {
      .icons {
        width: 40px;
        min-width: 40px;
      }

      p {
        font-size: 0.875rem;
      }
    }
  }
`;

const ReportButton = styled(ButtonTransparent)`
  @media (max-width: ${props => props.theme.screenSmMax}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 0 !important;
    border-top: 1px solid ${props => props.theme.gray200};
    border-bottom: 1px solid ${props => props.theme.gray200};
  }
`;

const AlertIsEmpty = styled.div`

  .alert {
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    padding-right: 0;
    padding-left: 0;
  }

`;

const FixInBottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #fff;
  border: 0;
  border-radius: 8px 8px 0 0;
  z-index: 105;

  @media (min-width: ${props => props.theme.screenSmMax}) {
    display: none !important;
  }
`;